<template>
    <div class="eos">
		<div class="eos__header">
			<h2 class="eos__header--title">Shift configurations</h2>
			<div class="eos__header--actions">
				<div>
                    <el-date-picker
                        v-model="filterDate"
                        type="date"
                        placeholder="Select date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="eos__header--date-picker"
                    ></el-date-picker>
                </div>
				<button class="eos__header--btn" @click="showEos = true">Create Shift Config</button>
			</div>
		</div>

        <EosList
            :eosList="eosList"
            :loading="loading"
            @edit="editEos"
            @delete="deleteEos"
        />

        <EosDeleteDialog
            :visible.sync="deleteEosShow"
            @cancel="deleteEosShow = false"
            @confirm="deleteConfirmEos"
        />

        <el-dialog :visible.sync="showEos" :modal-append-to-body="false" :show-close='false' class="eos__dialog">
            <EosForm
                :eosForm="eosForm"
                :rules="rules"
                :venues="venues"
                :daysOfWeekList="daysOfWeekList"
                :loading="loading"
                :title="title"
                :editEosVenueId="editEosVenueId"
                :activeSequences="activeSequences"
                :activeServices="activeServices"
                @change-venue="changeVenue"
                @add-shift="addShift"
                @add-service="addService"
                @remove-shift="removeShift"
                @remove-service="removeService"
                @cancel="showEos = false"
                @submit="handleSubmit"
            />
        </el-dialog>

        <EosRemoveShiftDialog
            :visible.sync="showRemoveShiftConfirm"
            @cancel="showRemoveShiftConfirm = false"
            @confirm="confirmRemoveShift"
        />

        <EosRemoveServiceDialog
            :visible.sync="showRemoveServiceConfirm"
            @cancel="showRemoveServiceConfirm = false"
            @confirm="confirmRemoveService"
        />
	</div>  
</template>

<script>
import api from '../../api/account'
import EosList from './components/EosList.vue'
import EosForm from './components/EosForm.vue'
import EosDeleteDialog from './components/EosDeleteDialog.vue'
import EosRemoveShiftDialog from './components/EosRemoveShiftDialog.vue'
import EosRemoveServiceDialog from './components/EosRemoveServiceDialog.vue'
import eos from '../../api/eos'

export default {
    props: {
        venueId: {
            type: Number,
            required: true
        }
    },
    components: {
        EosList,
        EosForm,
        EosDeleteDialog,
        EosRemoveShiftDialog,
        EosRemoveServiceDialog
    },
    data() {
        return {
            deleteEosDate: null,
            deleteEosShow: false,
            editEosVenueId: null,
            loading: false,
            eosList: [],
            eos: null,
            showEos: false,
            title: 'Create Shift Configuration',
            activeSequences: ['sequence-1'],
            activeServices: ['service-1'],
            showRemoveShiftConfirm: false,
            showRemoveServiceConfirm: false,
            shiftToRemove: null,
            filterDate: new Date().toISOString().split('T')[0],
            serviceToRemove: {
                shiftIndex: null,
                serviceIndex: null
            },
            rules: {
                venueId: [
                    { required: true, message: 'Please select a venue', trigger: 'change' }
                ],
                from: [
                    { required: true, message: 'Please select a start date', trigger: 'change' }
                ]
            },
            eosForm: {
                venueId: parseInt(this.$route.params.id),
                venueName: '',
                from: '',
                shifts: [
                    {
                        sequence: 1,
                        name: '',
                        startTime: '',
                        services: [
                            {
                                name: '',
                                startTime: '',
                                daysOfWeek: [],
                            }
                        ],
                    }
                ],
            },

            venues: [],

            daysOfWeekList: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
        }
    },
    watch: {
        filterDate: {
            handler(newVal) {
                this.getEosConfigList()
            },
        }
    },
    methods: {
        createEos() {
            this.showEos = true;
            this.title = 'Create Shift Configuration';
            this.editEosVenueId = null;
        },
        editEos(row) {
            this.showEos = true;
            this.title = 'Copy And Create Shift Configuration';
            this.eosForm = row;
            this.editEosVenueId = row.venueId;
        },
        deleteEos(row) {
            this.deleteEosDate = row.from;
            this.deleteEosShow = true;
        },
        async deleteConfirmEos() {
            await eos.deleteEosConfig(this.venueId, this.deleteEosDate)

            this.getEosConfigList()

            this.deleteEosShow = false;
        },
        changeVenue(value) {
            if (value) {
                this.eosForm.id = value;
                this.eosForm.venueName = this.venues.find(venue => venue.value === value).label;    
            }
        },
        getEosList() {
            
        },
        addShift() {
            this.eosForm.shifts.push({
                sequence: this.eosForm.shifts.length + 1,
                name: '',
                startTime: '',
                services: [
                    {
                        name: '',
                        startTime: '',
                        daysOfWeek: [],
                    }
                ],
            });
        },
        addService(index) {
            this.eosForm.shifts[index].services.push({
                name: '',
                startTime: '',
                daysOfWeek: [],
            });
        },
        removeShift(index) {
            this.shiftToRemove = index;
            this.showRemoveShiftConfirm = true;
        },
        removeService({shiftIndex, serviceIndex}) {
            this.serviceToRemove = {
                shiftIndex: shiftIndex,
                serviceIndex: serviceIndex
            };

            this.showRemoveServiceConfirm = true;
        },
        confirmRemoveShift() {
            this.eosForm.shifts.splice(this.shiftToRemove, 1);
            this.showRemoveShiftConfirm = false;
            this.shiftToRemove = null;
        },
        confirmRemoveService() {

            this.eosForm.shifts[this.serviceToRemove.shiftIndex].services.splice(this.serviceToRemove.serviceIndex, 1);
            this.showRemoveServiceConfirm = false;
            this.serviceToRemove = {
                shiftIndex: null,
                serviceIndex: null
            };
        },
        async handleSubmit(eosForm) {
            this.loading = true;

            try {
                await eos.saveEosConfig(this.venueId, eosForm.from, eosForm.shifts)

                this.eosForm = {
                    id: 1,
                    venueId: parseInt(this.$route.params.id),
                    venueName: '',
                    from: '',
                    shifts: [
                        {
                            sequence: 1,
                            name: '',
                            startTime: '',
                            services: [
                                {
                                    name: '',
                                    startTime: '',
                                    daysOfWeek: [],
                                }
                            ],
                        }
                    ],
                };

                this.getEosConfigList()

                this.loading = false;
                this.showEos = false;

            } catch (error) {
                this.loading = false;
                return;
            }
            
        },
        async getEosConfigList() {
            const res = await eos.getEosConfigList(this.venueId, this.filterDate)
            this.eosList = res.map(eos => ({
                ...eos,
                venueId: parseInt(this.$route.params.id),
                venueName: '',
                shifts: eos.shifts && eos.shifts.length > 0 ? eos.shifts.map(shift => ({
                    ...shift,
                    services: shift.services && shift.services.length > 0 ? shift.services : []
                })) : []
            }));
        }
    },
    async mounted() {
        this.getEosConfigList()
      
        api.subVenueList({callback: (res) => {
            console.log('res: ', res.data.code);
            if (res.data.code === 0) {
                this.venues = res.data.data
                    .sort((a, b) => a.venueName.localeCompare(b.venueName)) // sort alphabetically
                    .map(item => ({
                        value: item.venueId,
                        label: `${item.venueName}`
                    }))

            }
        }})
    }

}
</script>


// WEBPACK FOOTER //
// src/components/eos/index.vue